import React from 'react';
import classnames from 'classnames';
import {Translations} from '../../../utils';

class Password extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      inputInValid: undefined,
      inputValue: '',
      validationMsg: ''
    };
  }

  handleInputChange = (e) => {
    this.validateInput(e);
    this.setState({inputValue: e.target.value});
    this.props.setInputvalue(e.target.value, e.target.name);
  }

  setInputAsValid = (fieldName) => {
    this.setState({inputInValid: false});
    this.props.setFieldValidtionState(fieldName, "valid");
  }

  setInputAsInValid = (fieldName, validationMsg) => {
    this.setState({inputInValid: true, validationMsg});
    this.props.setFieldValidtionState(fieldName, "invalid");
  }

  validateInput = (event) => {
    const value = event.target.value;
    var newPasswordregx = "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\\$%^/&*_`{|}~¬£?&=<>:;()+-])(?=.{10,30})";
    // mandatory validation for input when set mandatory
    if(this.props.mandatory === "true") {
      // basic input validation
      if(value !== "") {
        this.setInputAsValid(event.target.name);
      }else {
        this.setInputAsInValid(event.target.name, this.props.mandatoryMessage);
      }
    }

    // regex validation for input when regex is set
    if(value !== "" && this.props.regexPattern) {

      if(new RegExp(this.props.name === 'newPassword' ? newPasswordregx : this.props.regexPattern).test(value)) {
        this.setInputAsValid(event.target.name);
      }else {
        this.setInputAsInValid(event.target.name, this.props.regexValidationMessage);
      }
    }else if(this.props.mandatory !== "true" && value === "" && this.props.regexPattern) {
      this.setInputAsValid(event.target.name);
    }

    // if(this.props.mandatory === "true") {
    //   // basic input validation
    //   if(value !== "") {
    //     this.setInputAsValid(event.target.name);
    //   }else {
    //     this.setInputAsInValid(event.target.name);
    //   }
    //   // regex validation
    //   if(this.props.regexPattern) {
    //     if(this.props.regexPattern.test(value)) {
    //       this.setInputAsValid(event.target.name);
    //     }else {
    //       this.setInputAsInValid(event.target.name);
    //     }
    //   }
    // }
  }

  render(){
    const inputErrorCss = classnames({
      "gdocs-input-error": this.state.inputInValid
    });
    return(
      <div>
        <input type="password"
               className={inputErrorCss}
               name={this.props.name}
               id={this.props.name}
               defaultValue={this.props._value}
               value={this.state.inputValue}
               minLength={this.props.min}
               maxLength={this.props.max}
               onChange={this.handleInputChange}
               onBlur={this.validateInput}
               readOnly={this.props.disabled}
               aria-labelledby={this.props.name}
               aria-describedby={`${this.props.name}error hints`}
               ref={(input) => { this.nameInput = input }}
          />
        {
          this.state.inputInValid ? (
            <div className="input-error-msg-section" id={`${this.props.name}error`} role="alert">
              <span className="icon icon-circle-delete-solid"></span>{Translations(this.state.validationMsg, this.props.lang, this.props.translatedData)}
            </div>
          ) : ''
        }
      </div>
    )
  }
}

export default Password;



// WEBPACK FOOTER //
// ./src/components/common/Password/index.js